module.exports = __webpack_public_path__ + "img/bg-intro-desktop.9cea2f98.svg";